import * as React from 'react'
import Typography from '@mui/material/Typography'
import RadioGroup from '@mui/material/RadioGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import Radio from '@mui/material/Radio'
import FormHelperText from '@mui/material/FormHelperText'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Button from '@mui/material/Button'

import { TextField } from '@workwave-tidal/core/components'
import { useFormFields } from './hooks/useFormFields'
import { useData } from './hooks/useData'
import Paper from '@mui/material/Paper'
import { useTheme } from '@mui/material/styles'

type Props = {
  isOpportunityStageMeter: boolean
}

export default function ClosedReason(props: Props) {
  const { isOpportunityStageMeter } = props
  const {
    customReasonField,
    customReasonHelperText,
    onFocusCustomReason,
    customReasonRef,
    reasonField,
    onCancelClick,
  } = useFormFields({ isOpportunityStageMeter })

  const {
    allowManualDisqualifyReasons,
    closeLostReasons,
    customReasonError,
    reasonIdError,
    reasonIdErrorTxt,
    closedLostReasonId,
  } = useData()
  const theme = useTheme()
  return (
    <Paper
      variant="outlined"
      sx={{
        p: 1,
        gap: 1,
        mt: 1,
        border: reasonIdError
          ? `1px solid ${theme.palette.error.main}`
          : `none`,
        backgroundColor: theme.palette.background.default,
      }}
    >
      <Stack
        direction={'row'}
        alignItems="center"
        justifyContent="space-between"
      >
        <Typography
          variant="body1"
          sx={{
            color: reasonIdError
              ? theme.palette.error.main
              : theme.palette.text.primary,
          }}
        >
          Closed Lost Reason*
        </Typography>
        {isOpportunityStageMeter && (
          <Button
            onClick={onCancelClick}
            size="small"
            sx={{ textTransform: 'none' }}
            variant="text"
            data-test-id="closedReasonCancelButton"
          >
            Cancel
          </Button>
        )}
      </Stack>
      <RadioGroup {...reasonField}>
        {closeLostReasons?.length > 0 &&
          closeLostReasons.map((reason) => (
            <FormControlLabel
              key={reason.id}
              control={<Radio size="medium" />}
              label={reason.reason}
              value={reason.id.toString()}
              sx={{ marginLeft: 0, marginBottom: 0, width: 'fit-content' }}
              data-test-id={`closedReasonRadio-${reason.id}`}
            />
          ))}

        {allowManualDisqualifyReasons && (
          <FormControlLabel
            value="0"
            control={<Radio />}
            label="Custom Reason"
            sx={{ marginLeft: 0, marginBottom: 0, width: 'fit-content' }}
            data-test-id="closedReasonRadioCustom"
          />
        )}
      </RadioGroup>

      {allowManualDisqualifyReasons && (
        <Box ml={4} mt={1}>
          <TextField
            {...customReasonField}
            avoidDisplayingErrorIcon
            fullWidth
            required={closedLostReasonId == 0}
            inputRef={customReasonRef}
            onFocus={onFocusCustomReason}
            inputProps={{
              maxLength: 50,
              sx: { backgroundColor: theme.palette.common.white },
            }}
            label="Custom Reason"
            helperText={customReasonHelperText}
            error={customReasonError}
            data-test-id="closedReasonRadioCustomReasonInput"
          />
        </Box>
      )}
      <FormHelperText sx={{ ml: 1 }} error={reasonIdError}>
        {reasonIdErrorTxt}
      </FormHelperText>
    </Paper>
  )
}
